export default __webpack_public_path__ + "static/media/Pinterest.444a2d34.svg";